import Module, { ViewLayer, moduleInit, bindButtonClickEvent } from "../../../../framework/core/mvvm/module_base";
import { QuickBuyView } from "./quick_buy_view";
import ActivityUtil from "../activity/activity_util";
import ModelData, { IUserData } from "../../../public/model_data";
import PromiseUtility from "../../../../utility/promiseUtility";
import ModuleManager from "../../../../framework/core/module_manager";
import GoogleBillingController from "../../../../sdk/googlebilling_controller";

const {ccclass, property} = cc._decorator;

@ccclass
@moduleInit('QuickBuy')
export class QuickBuy extends Module<QuickBuyView,null> {
    constructor() {
        super();
        this.layer = ViewLayer.Mid;
        this.windowPrefabResPath = "package/hall/module/quickbuy/quick_buy";
        this.viewType = QuickBuyView
        this.modelType = null
        this.autoShowAnim = true
        this.needAnim = true
        this.needViewMask = true
        this.needViewBaseCloseBtn = true;
        this.needViewBaseTitleBg = false
        this.needViewBaseBg = false
        this.needDeferShow = true
        this.clickAnywhereClose = false;
    }

    protected vipMap:Map<string,number> = null;

    protected needByItem:any

    onInit(intenData){
        this.vipMap = new Map<string,number>();
        this.vipMap.set('SYS_Vip_Scard',0);
        this.vipMap.set('SYS_Vip_Gcard',1);
        this.vipMap.set('SYS_Vip_Dcard',2);
        this.eventBind('googleBillingPurchaseSuccess',this.googleBillingPurchaseSuccess);
    }

    onDeferShow(intenData) {
        this.getData((data:any)=>{
            if (data && data.data.length > 0) {
                this.updatePanel(data)
                this.show();
            }
        })
    }

    getData(func?:Function){
        let goods = {
            data:null,
            user:null,
        };
        let quick_buy = (cb)=>{
            ActivityUtil.getQuickBuyList((data:any)=>{
                goods.data = data;
                cb();
            },()=>{},this)
        }

        let getUserData = (cb)=>{
            this.getUserData(ModelData.instance.roleData.id,(userdata:IUserData)=>{
                if (this.nodeIsValid) {
                    goods.user = userdata;
                    cb()
                }
            },true)
        }

        PromiseUtility.all([quick_buy,getUserData]).then(()=>{
            func && func(goods);
        })
     
    }

    updatePanel(goods:any){
        let items = goods.data;
        let user = goods.user;
        this.needByItem = this.reasonableGoods(items,user);
        if (this.needByItem) {
            this.view.updateUI(this.needByItem);
        }else{
            cc.log('no goods')
        }
    }

    //栓选
    reasonableGoods(items:any,userdata:IUserData){
        //优先根据vip栓选
        //黑金>金>银
        let goods = [];
        let vipList = userdata.vipConfigList.concat([]);
        if (vipList.length > 0) {
            vipList.sort((a,b)=>{
                let code1 = this.vipMap.get(a.code)
                let code2 = this.vipMap.get(b.code)
                return code2 - code1;
            })
        }

        //优先vip
        for (let j = 0; j < vipList.length; j++) {
            let vipItem = vipList[j];
            for (let i = 0; i < items.length; i++) {
                let data = items[i];
                if (vipItem.code == data.vipCode) {
                    goods.push(data);
                }
            }
            if (goods.length > 0) {
                break;
            }
        }

        let getRecomendItem = (sortItems:any[],lv:number)=>{
            let curItem = null;
            let curDis = 0;
            for (let i = 0; i < sortItems.length; i++) {
                let item = sortItems[i];
                let userlv = item.userLevel == 0 ? 1:item.userLevel;
                lv = (lv == 0) ? 1: lv;
                let dis = Math.abs(userlv - lv)
                if (curDis == 0|| dis <= curDis) {
                    curItem = item;
                    curDis = dis;
                }
            }
            return curItem;
        }


        if (goods.length > 0) {//等级条件
            let item = getRecomendItem(goods,userdata.userLevel);
            return item;
        }
        //排除vip
        let expItems = [];
        for (let i = 0; i < items.length; i++) {
            let data = items[i];
            if (data.vipCode == '') {
                expItems.push(data);
            }
        }
        return getRecomendItem(expItems,userdata.userLevel);
    }

    @bindButtonClickEvent('close_btn')
    closePanel(){
        this.hide();
    }

    @bindButtonClickEvent('discount_btn')
    buyGoods_btn(){
        if (this.needByItem) {
            let goodv = this.needByItem.goodsVo

            if (goodv != undefined) {
                ModuleManager.instance.showModuleName("NetPrompt", { showImmediately: true })
                GoogleBillingController.purchaseInApp(goodv.goodsCode);
            }
        }
    }

    googleBillingPurchaseSuccess(skuId:string){
        let gold = 0;
        if (this.needByItem) {
            let goodv = this.needByItem.goodsVo
            gold += goodv.num;
            if (goodv.goodsCode == skuId) {
                for (let j = 0; j < goodv.giftList.length; j++) {
                    let gift = goodv.giftList[j];
                    gold += gift.num;
                }
            }

            ModuleManager.instance.showModuleName('DialogReceive', {chipNum: null, goldNum: gold})
            this.getSelfCurrencyData(null, true)
            this.eventDispatch('player_coinbalance_changed');
            this.getData((data:any)=>{
                if (data && data.data.length > 0) {
                    this.updatePanel(data)
                    this.hide();
                }
            })
        }
    }
}
